/** Situações dos títulos a receber */
export interface TituloReceberSituacao {
    id: number;
    nome: string;
}

export const TituloReceberNormal: TituloReceberSituacao = {id: 1, nome: 'Normal'};
export const TituloReceberDescontado: TituloReceberSituacao = {id: 2, nome: 'Descontado'};
export const TituloReceberVendor: TituloReceberSituacao = {id: 3, nome: 'Vendor'};
export const TituloReceberDuvidoso: TituloReceberSituacao = {id: 4, nome: 'Duvidoso'};
export const TituloReceberPerdido: TituloReceberSituacao = {id: 5, nome: 'Perdido'};
export const TituloReceberEmGarantia: TituloReceberSituacao = {id: 6, nome: 'Em Garantia'};
export const TituloReceberProcessoJudicial: TituloReceberSituacao = {id: 7, nome: 'Processo Judicial'};
export const TituloReceberChequeDevolvido: TituloReceberSituacao = {id: 8, nome: 'Cheque Devolvido'};
export const TituloReceberAdiantamentoCliente: TituloReceberSituacao = {id: 9, nome: 'Adiantamento de Clientes'};
export const TituloReceberCartorio: TituloReceberSituacao = {id: 10, nome: 'Cartório'};
export const TituloReceberProtesto: TituloReceberSituacao = {id: 11, nome: 'Protesto'};
export const TituloReceberCobrancaSimples: TituloReceberSituacao = {id: 12, nome: 'Cobrança Simples'};
export const TituloReceberAcerto: TituloReceberSituacao = {id: 13, nome: 'Acerto'};
export const TituloReceberDeposito: TituloReceberSituacao = {id: 14, nome: 'Depósito'};
export const TituloReceberRenegociado: TituloReceberSituacao = {id: 15, nome: 'Renegociado'};
export const TituloReceberSPCSERASA: TituloReceberSituacao = {id: 16, nome: 'SPC/SERASA'};
export const TituloReceberOutraSituacao: TituloReceberSituacao = {id: 99, nome: 'Outra'};

export const tituloReceberSituacoes: TituloReceberSituacao[] = [
    TituloReceberNormal,
    TituloReceberDescontado,
    TituloReceberVendor,
    TituloReceberDuvidoso,
    TituloReceberPerdido,
    TituloReceberEmGarantia,
    TituloReceberProcessoJudicial,
    TituloReceberChequeDevolvido,
    TituloReceberAdiantamentoCliente,
    TituloReceberCartorio,
    TituloReceberProtesto,
    TituloReceberCobrancaSimples,
    TituloReceberAcerto,
    TituloReceberDeposito,
    TituloReceberRenegociado,
    TituloReceberSPCSERASA,
    TituloReceberOutraSituacao
];
